import { CursorAction } from '../modules/mirror-hover-focus';

const mirrorHoverFocusInstances = [];
const mirrorHoverFoci = Array.from(
  document.querySelectorAll('[data-mirror-hover-focus]')
);

mirrorHoverFoci.forEach(mirrorHoverFocus => {
  const config = JSON.parse(
    mirrorHoverFocus.dataset.mirrorHoverFocus.replaceAll("'", '"')
  );
  const mirrorHoverFocusInstance = new CursorAction(mirrorHoverFocus, config);
  mirrorHoverFocusInstances.push(mirrorHoverFocusInstance);
  mirrorHoverFocusInstance.activate();
});
